import { StateKey } from 'common/utils/flipState'
import { isErrorRejected } from 'common/utils/ajax/apiErrorHandler'
import { PayMemberResponse } from 'common/types/entities/api/pay'
import { GradeStatus } from 'common/constants/naverPay'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

const initialState: PayMemberResponse = {
  apiSuccess: false,
  exceptionMessage: '',
  payMemberAgreeYn: false,
  payMemberNo: 0,
  sudpendStatusYn: false,
  leaveStatusYn: false,
  gradeStatusCode: GradeStatus.NONE,
}

const FETCH = 'my/payMemberStatus/FETCH'

export const fetchPayMemberStatus = (curState: StateKey, headers?: any) => async dispatch => {
  const response = await axios.get('/v1/pay/member-status', {
    ...getHeaders(headers),
    data: {
      [isErrorRejected]: true,
    },
  })
  dispatch({
    curState,
    type: FETCH,
    payMemberStatus: response && response.data,
  })
}

const payMemberStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return action.payMemberStatus
    default:
      return state
  }
}

export default payMemberStatusReducer
